import React, { Component } from 'react';
import { connect } from 'react-redux';

import { logout } from '../../modules/auth';
import { init } from '../../modules/app';

class Logout extends Component {
  async componentDidMount() {
    const { dispatch, history } = this.props;

    await this.props.dispatch(logout());
    console.log('a');
    history.push('/login');
    dispatch(init());
  }

  render() {
    return <div />
  }
}

export default connect()(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout/index.js